module.exports = __webpack_public_path__ + "static/media/malyar.b6b008c5.png";